import { Text as RadixText, type TextProps } from "@radix-ui/themes";

export function Text(props: TextProps) {
  return <RadixText {...props} />;
}
